<template>
  <div class="ldr" v-if="loading" role="status" aria-label="Loading">
    <div class="ldr__ring"></div>
  </div>
</template>
<script>
export default {
  props: ["loading"]
};
</script>
<style scoped>
.ldr {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.ldr__ring {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 3px solid var(--accent-050);
  border-top-color: var(--accent-600);
  animation: ldr-spin 0.7s linear infinite;
}

@keyframes ldr-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .ldr__ring {
    animation-duration: 1.6s;
  }
}
</style>
